import { Type } from 'class-transformer';
import { ValidateNested } from 'class-validator';
import { InvoiceBillingCreateDto } from './invoice-billing.create.dto';

export class InvoiceBillingCreateManyDto {
  @ValidateNested({each: true})
  @Type(() => InvoiceBillingCreateDto)
  bulk: InvoiceBillingCreateDto[];
}